import { Avatar, Typography } from "@mui/material";

export default function Profile({ profile }) {
    return (
        <div className="ProfileAvatar">
            <Avatar
                sx={{ width: "15rem", height: "15rem" }}
                alt="photo"
                src={profile.photo}
            />
            <br></br>
            <Typography variant="h5">{profile.name}</Typography>
            <Typography variant="subtitle1">{profile.affiliation}</Typography>
        </div>
    );
}
